import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Typography } from 'components/atoms';

type Props = {
  className: string;
  message: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  mapNotice: {
    alignItems: 'center',
    backgroundColor: theme.palette.common.black,
    display: 'flex',
    justifyContent: 'center',
    minHeight: '40px',
    padding: theme.spacing(0.25, 1),
    width: '200px',

    '& .fd-text': {
      color: theme.palette.common.white,
      textAlign: 'center',
    },
  },
}));

export function MapNotice(props: Props): JSX.Element {
  const classes = useStyles();

  const { className, message } = props;

  const mapNoticeStyles = clsx(classes.mapNotice, className || '');

  return (
    <div className={mapNoticeStyles}>
      <Typography variant="fineprint">{message}</Typography>
    </div>
  );
}
